export const ECfopLocal = [
    { key: 1, value:"CFTP_ENTRADA_ESTADUAL", text: "1 - Entrada Estadual"},
    { key: 2, value:"CFTP_ENTRADA_INTERESTADUAL", text: "2 - Entrada Interestadual" },
    { key: 3, value:"CFTP_ENTRADA_IMPORTACAO ",text: "3 - Importação" },
    { key: 5, value:"CFTP_SAIDA_ESTADUAL",text: "5 - Saida Estadual" },
    { key: 6, value:"CFTP_SAIDA_INTERESTADUAL",text: "6 - Saida Interestadual" },
    { key: 7, value:"CFTP_SAIDA_EXPORTACAO",text: "7 - Exportação" },
  ];